//Styles / MUID
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

import { indigo, orange, red } from "@material-ui/core/colors";

const defaultTheme = createMuiTheme({
  palette: {
    fontFamily: "Roboto, sans-serif",
    primary: {
      main: indigo["500"],
      contrastText: "#fff"
    },
    secondary: {
      main: orange["500"],
      contrastText: "#000"
    },
    error: {
      main: red["500"],
      contrastText: "#fff"
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161"
    },
    contrastThreshold: 3
  }
});

export default defaultTheme;



// WEBPACK FOOTER //
// ./src/styles/themes/defaultTheme.js